import { render, staticRenderFns } from "./new_password.vue?vue&type=template&id=6608d362&scoped=true"
import script from "./new_password.vue?vue&type=script&lang=js"
export * from "./new_password.vue?vue&type=script&lang=js"
import style0 from "./new_password.vue?vue&type=style&index=0&id=6608d362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6608d362",
  null
  
)

export default component.exports